import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';

@Component({
    selector: 'app-confirm-signup',
    templateUrl: './confirm-signup.component.html',
})
export class ConfirmSignupComponent {
    confirmSignUpForm: FormGroup;
    submitted = false;
    isOTPNumeric = true;
    userObj;
    countdown: number = 60; // Set the initial countdown value (in seconds)
    interval: any;
    showCountdown = true;
    resendCode = false;

    constructor(
        private authService: AuthService,
        private fb: FormBuilder,
        private router: Router
    ) {
        this.userObj =
            this.router.getCurrentNavigation().extras.state?.userDetails;
    }

    ngOnInit() {
        this.confirmSignUpForm = this.fb.group({
            confirmationCode: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]+$/)],
            ],
        });

        this.startCountdown();
    }

    get f() {
        return this.confirmSignUpForm.controls;
    }

    startCountdown() {
        this.interval = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
                this.showCountdown = true;
            } else {
                clearInterval(this.interval);
                this.showCountdown = false;
            }
        }, 1000); // Update the countdown every 1 second (1000 ms)
    }

    onResendCode() {
        this.countdown = 60;
        this.showCountdown = true;
        this.startCountdown();

        let resendDetails = {
            username: this.userObj?.username,
        };

        this.authService.resendSignUpEmail(resendDetails).subscribe(
            (res) => {},
            (err) => {}
        );
    }

    onConfirmDetails() {
        this.submitted = true;
        const confirmationDetails = {
            username: this.userObj?.username,
            confiramtionCode: this.confirmSignUpForm.value.confirmationCode,
        };

        if (this.confirmSignUpForm.valid) {
            this.authService.confirmUserSignUp(confirmationDetails).subscribe(
                (res) => {},
                (err) => {}
            );
        }
    }
}
